import { Fragment } from 'react';
import { Box, Typography } from '@pocketlaw/tetris';
import { useSafeSearchResultText } from '../../../hooks/useSafeSearchResultText';
export function Match(props) {
    const { name, highlight } = props;
    const { result, showNameOnly } = useSafeSearchResultText({ name, highlight });
    return (<Box flexDirection="column" style={{ minWidth: 0 }}>
      {showNameOnly ? (<Typography $truncate $fontSize="small" $appearance="300">
          {result}
        </Typography>) : (<Fragment>
          <Typography $truncate $fontSize="small" $appearance="300">
            {name}
          </Typography>
          <Typography $truncate $appearance="100" $fontSize="tiny">
            … {result} …
          </Typography>
        </Fragment>)}
    </Box>);
}
